module.exports = __webpack_public_path__ + "static/img/icon_baby_girl.94e32fec.png";